export const environment = {
    production: true,
    develop: true,
    showChatbot: true,
    firebase: {
        apiKey: "AIzaSyCgX7fQDXqqrkTUcEcdx38on6Wq6bjQN-g",
        authDomain: "tg24-038-ec1ce.firebaseapp.com",
        projectId: "tg24-038-ec1ce",
        storageBucket: "tg24-038-ec1ce.firebasestorage.app",
        messagingSenderId: "279232662596",
        appId: "1:279232662596:web:7a654fcfacb404cc8bc011",
        measurementId: "G-G7QPZSJK4J"
    }
};


export const URLS = {
    API: 'https://api.7maravillaslaoliva.com/',
    GEOJSON: 'servir_geojson',
    GEOSON_SLIM: 'servir_geojson_ligero',
    chatbot: 'olviaAI_STREAM',
    FICHA: 'ficha/',
    ALEATORIO: 'aleatorio',
    PUNTOS_MAPA: 'puntos_mapa',
    ALOJAMIENTOS: 'alojamientos',
    NUEVA_FICHA: 'nueva_ficha_geojson',
    ELIMINAR_FICHA: 'borrar_ficha_geojson',
    EXPORTAR_XLSX: 'exportar_formularios_xlsx'
}